// @generated by protoc-gen-es v2.11.0 with parameter "target=ts+js"
// @generated from file lease/merchant/v1/api.proto (package lease.merchant.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../google/api/field_behavior_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_lease_common_v1_types } from "../common/v1/types_pb";

/**
 * Describes the file lease/merchant/v1/api.proto.
 */
export const file_lease_merchant_v1_api = /*@__PURE__*/
  fileDesc("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", [file_google_api_field_behavior, file_google_protobuf_timestamp, file_lease_common_v1_types]);

/**
 * Describes the message lease.merchant.v1.RefundRequest.
 * Use `create(RefundRequestSchema)` to create a new message.
 */
export const RefundRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 0);

/**
 * Describes the message lease.merchant.v1.RefundResponse.
 * Use `create(RefundResponseSchema)` to create a new message.
 */
export const RefundResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 1);

/**
 * Describes the message lease.merchant.v1.ListCustomersRequest.
 * Use `create(ListCustomersRequestSchema)` to create a new message.
 */
export const ListCustomersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 2);

/**
 * Describes the message lease.merchant.v1.ListCustomersResponse.
 * Use `create(ListCustomersResponseSchema)` to create a new message.
 */
export const ListCustomersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 3);

/**
 * Describes the message lease.merchant.v1.Customer.
 * Use `create(CustomerSchema)` to create a new message.
 */
export const CustomerSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 4);

/**
 * Describes the message lease.merchant.v1.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 5);

/**
 * Describes the message lease.merchant.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 6);

/**
 * Describes the message lease.merchant.v1.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 7);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsRequest.
 * Use `create(ListProductTrackableItemsRequestSchema)` to create a new message.
 */
export const ListProductTrackableItemsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 8);

/**
 * Describes the message lease.merchant.v1.TrackableItemLocation.
 * Use `create(TrackableItemLocationSchema)` to create a new message.
 */
export const TrackableItemLocationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 9);

/**
 * Describes the message lease.merchant.v1.TrackableItem.
 * Use `create(TrackableItemSchema)` to create a new message.
 */
export const TrackableItemSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 10);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsResponse.
 * Use `create(ListProductTrackableItemsResponseSchema)` to create a new message.
 */
export const ListProductTrackableItemsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 11);

/**
 * Describes the message lease.merchant.v1.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 12);

/**
 * Describes the message lease.merchant.v1.UpdateProductResponse.
 * Use `create(UpdateProductResponseSchema)` to create a new message.
 */
export const UpdateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 13);

/**
 * Describes the message lease.merchant.v1.CreateProductRequest.
 * Use `create(CreateProductRequestSchema)` to create a new message.
 */
export const CreateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 14);

/**
 * Describes the message lease.merchant.v1.CreateProductResponse.
 * Use `create(CreateProductResponseSchema)` to create a new message.
 */
export const CreateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 15);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemRequest.
 * Use `create(CreateTrackableItemRequestSchema)` to create a new message.
 */
export const CreateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 16);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemResponse.
 * Use `create(CreateTrackableItemResponseSchema)` to create a new message.
 */
export const CreateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 17);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemRequest.
 * Use `create(UpdateTrackableItemRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 18);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemResponse.
 * Use `create(UpdateTrackableItemResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 19);

/**
 * Describes the message lease.merchant.v1.ListMachinesRequest.
 * Use `create(ListMachinesRequestSchema)` to create a new message.
 */
export const ListMachinesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 20);

/**
 * Describes the message lease.merchant.v1.MachineInfo.
 * Use `create(MachineInfoSchema)` to create a new message.
 */
export const MachineInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 21);

/**
 * Describes the message lease.merchant.v1.ListMachinesResponse.
 * Use `create(ListMachinesResponseSchema)` to create a new message.
 */
export const ListMachinesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 22);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsRequest.
 * Use `create(ListMachineProductMapsRequestSchema)` to create a new message.
 */
export const ListMachineProductMapsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 23);

/**
 * Describes the message lease.merchant.v1.ProductMap.
 * Use `create(ProductMapSchema)` to create a new message.
 */
export const ProductMapSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 24);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsResponse.
 * Use `create(ListMachineProductMapsResponseSchema)` to create a new message.
 */
export const ListMachineProductMapsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 25);

/**
 * Describes the message lease.merchant.v1.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 26);

/**
 * Describes the message lease.merchant.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 27);

/**
 * Describes the message lease.merchant.v1.RefundStatus.
 * Use `create(RefundStatusSchema)` to create a new message.
 */
export const RefundStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 28);

/**
 * Describes the message lease.merchant.v1.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 29);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersRequest.
 * Use `create(ListCustomerOrdersRequestSchema)` to create a new message.
 */
export const ListCustomerOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 30);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersResponse.
 * Use `create(ListCustomerOrdersResponseSchema)` to create a new message.
 */
export const ListCustomerOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 31);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateRequest.
 * Use `create(UpdateTrackableItemStateRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemStateRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 32);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateResponse.
 * Use `create(UpdateTrackableItemStateResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemStateResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 33);

/**
 * Describes the message lease.merchant.v1.OpenDoorsRequest.
 * Use `create(OpenDoorsRequestSchema)` to create a new message.
 */
export const OpenDoorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 34);

/**
 * Describes the message lease.merchant.v1.OpenDoorsResponse.
 * Use `create(OpenDoorsResponseSchema)` to create a new message.
 */
export const OpenDoorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 35);

/**
 * Describes the message lease.merchant.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 36);

/**
 * Describes the message lease.merchant.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 37);

/**
 * Describes the message lease.merchant.v1.GetStatsRequest.
 * Use `create(GetStatsRequestSchema)` to create a new message.
 */
export const GetStatsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 38);

/**
 * Describes the message lease.merchant.v1.GetStatsResponse.
 * Use `create(GetStatsResponseSchema)` to create a new message.
 */
export const GetStatsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 39);

/**
 * Describes the message lease.merchant.v1.Stats.
 * Use `create(StatsSchema)` to create a new message.
 */
export const StatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 40);

/**
 * Describes the message lease.merchant.v1.PaymentInformation.
 * Use `create(PaymentInformationSchema)` to create a new message.
 */
export const PaymentInformationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 41);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoRequest.
 * Use `create(GetMyOrganizationInfoRequestSchema)` to create a new message.
 */
export const GetMyOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 42);

/**
 * Describes the message lease.merchant.v1.OrganizationInfo.
 * Use `create(OrganizationInfoSchema)` to create a new message.
 */
export const OrganizationInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 43);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoResponse.
 * Use `create(GetMyOrganizationInfoResponseSchema)` to create a new message.
 */
export const GetMyOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 44);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoRequest.
 * Use `create(UpdateOrganizationInfoRequestSchema)` to create a new message.
 */
export const UpdateOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 45);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoResponse.
 * Use `create(UpdateOrganizationInfoResponseSchema)` to create a new message.
 */
export const UpdateOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 46);

/**
 * Describes the message lease.merchant.v1.GetMyInfoRequest.
 * Use `create(GetMyInfoRequestSchema)` to create a new message.
 */
export const GetMyInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 47);

/**
 * Describes the message lease.merchant.v1.UserInfo.
 * Use `create(UserInfoSchema)` to create a new message.
 */
export const UserInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 48);

/**
 * Describes the message lease.merchant.v1.GetMyInfoResponse.
 * Use `create(GetMyInfoResponseSchema)` to create a new message.
 */
export const GetMyInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 49);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineRequest.
 * Use `create(UpdateVendingMachineRequestSchema)` to create a new message.
 */
export const UpdateVendingMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 50);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineResponse.
 * Use `create(UpdateVendingMachineResponseSchema)` to create a new message.
 */
export const UpdateVendingMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 51);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlRequest.
 * Use `create(GetUploadUrlRequestSchema)` to create a new message.
 */
export const GetUploadUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 52);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlResponse.
 * Use `create(GetUploadUrlResponseSchema)` to create a new message.
 */
export const GetUploadUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 53);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapRequest.
 * Use `create(UpdateProductMapRequestSchema)` to create a new message.
 */
export const UpdateProductMapRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 54);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapResponse.
 * Use `create(UpdateProductMapResponseSchema)` to create a new message.
 */
export const UpdateProductMapResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 55);

/**
 * Describes the message lease.merchant.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 56);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineRequest.
 * Use `create(SendEventToMachineRequestSchema)` to create a new message.
 */
export const SendEventToMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 57);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineResponse.
 * Use `create(SendEventToMachineResponseSchema)` to create a new message.
 */
export const SendEventToMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 58);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesRequest.
 * Use `create(OrderDailySummariesRequestSchema)` to create a new message.
 */
export const OrderDailySummariesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 59);

/**
 * Describes the message lease.merchant.v1.OrderDailySummary.
 * Use `create(OrderDailySummarySchema)` to create a new message.
 */
export const OrderDailySummarySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 60);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesResponse.
 * Use `create(OrderDailySummariesResponseSchema)` to create a new message.
 */
export const OrderDailySummariesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 61);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersRequest.
 * Use `create(ListCellOrdersRequestSchema)` to create a new message.
 */
export const ListCellOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 62);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersResponse.
 * Use `create(ListCellOrdersResponseSchema)` to create a new message.
 */
export const ListCellOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 63);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsRequest.
 * Use `create(GetCustomerAuthLogsRequestSchema)` to create a new message.
 */
export const GetCustomerAuthLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 64);

/**
 * Describes the message lease.merchant.v1.AuthLog.
 * Use `create(AuthLogSchema)` to create a new message.
 */
export const AuthLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 65);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsResponse.
 * Use `create(GetCustomerAuthLogsResponseSchema)` to create a new message.
 */
export const GetCustomerAuthLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 66);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusRequest.
 * Use `create(GetCustomerSMSDeliveryStatusRequestSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 67);

/**
 * Describes the message lease.merchant.v1.SMSDeliveryStatus.
 * Use `create(SMSDeliveryStatusSchema)` to create a new message.
 */
export const SMSDeliveryStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 68);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusResponse.
 * Use `create(GetCustomerSMSDeliveryStatusResponseSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 69);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeConfig.
 * Use `create(VenueAccessCodeConfigSchema)` to create a new message.
 */
export const VenueAccessCodeConfigSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 70);

/**
 * Describes the message lease.merchant.v1.VenueAccessCode.
 * Use `create(VenueAccessCodeSchema)` to create a new message.
 */
export const VenueAccessCodeSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 71);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesRequest.
 * Use `create(ListVenueAccessCodesRequestSchema)` to create a new message.
 */
export const ListVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 72);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesResponse.
 * Use `create(ListVenueAccessCodesResponseSchema)` to create a new message.
 */
export const ListVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 73);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesRequest.
 * Use `create(CreateVenueAccessCodesRequestSchema)` to create a new message.
 */
export const CreateVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 74);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesResponse.
 * Use `create(CreateVenueAccessCodesResponseSchema)` to create a new message.
 */
export const CreateVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 75);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeRequest.
 * Use `create(DeleteVenueAccessCodeRequestSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 76);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeResponse.
 * Use `create(DeleteVenueAccessCodeResponseSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 77);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageRequest.
 * Use `create(GetVenueAccessCodeUsageRequestSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 78);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsageStats.
 * Use `create(VenueAccessCodeUsageStatsSchema)` to create a new message.
 */
export const VenueAccessCodeUsageStatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 79);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsage.
 * Use `create(VenueAccessCodeUsageSchema)` to create a new message.
 */
export const VenueAccessCodeUsageSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 80);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageResponse.
 * Use `create(GetVenueAccessCodeUsageResponseSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 81);

/**
 * Describes the message lease.merchant.v1.AuthConfiguration.
 * Use `create(AuthConfigurationSchema)` to create a new message.
 */
export const AuthConfigurationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 82);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationRequest.
 * Use `create(GetAuthConfigurationRequestSchema)` to create a new message.
 */
export const GetAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 83);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationResponse.
 * Use `create(GetAuthConfigurationResponseSchema)` to create a new message.
 */
export const GetAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 84);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationRequest.
 * Use `create(UpdateAuthConfigurationRequestSchema)` to create a new message.
 */
export const UpdateAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 85);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationResponse.
 * Use `create(UpdateAuthConfigurationResponseSchema)` to create a new message.
 */
export const UpdateAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 86);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsRequest.
 * Use `create(ListMachineActuatorsRequestSchema)` to create a new message.
 */
export const ListMachineActuatorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 87);

/**
 * Describes the message lease.merchant.v1.ActuatorInfo.
 * Use `create(ActuatorInfoSchema)` to create a new message.
 */
export const ActuatorInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 88);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsResponse.
 * Use `create(ListMachineActuatorsResponseSchema)` to create a new message.
 */
export const ListMachineActuatorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 89);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorRequest.
 * Use `create(UpdateMachineActuatorRequestSchema)` to create a new message.
 */
export const UpdateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 90);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorResponse.
 * Use `create(UpdateMachineActuatorResponseSchema)` to create a new message.
 */
export const UpdateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 91);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorRequest.
 * Use `create(CreateMachineActuatorRequestSchema)` to create a new message.
 */
export const CreateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 92);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorResponse.
 * Use `create(CreateMachineActuatorResponseSchema)` to create a new message.
 */
export const CreateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 93);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorRequest.
 * Use `create(DeleteMachineActuatorRequestSchema)` to create a new message.
 */
export const DeleteMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 94);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorResponse.
 * Use `create(DeleteMachineActuatorResponseSchema)` to create a new message.
 */
export const DeleteMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 95);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryRequest.
 * Use `create(GetDoorStatusHistoryRequestSchema)` to create a new message.
 */
export const GetDoorStatusHistoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 96);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryResponse.
 * Use `create(GetDoorStatusHistoryResponseSchema)` to create a new message.
 */
export const GetDoorStatusHistoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 97);

/**
 * Describes the message lease.merchant.v1.DoorStatusHistoryEntry.
 * Use `create(DoorStatusHistoryEntrySchema)` to create a new message.
 */
export const DoorStatusHistoryEntrySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 98);

/**
 * Describes the message lease.merchant.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 99);

/**
 * Describes the message lease.merchant.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 100);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusRequest.
 * Use `create(UpdateUserStatusRequestSchema)` to create a new message.
 */
export const UpdateUserStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 101);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusResponse.
 * Use `create(UpdateUserStatusResponseSchema)` to create a new message.
 */
export const UpdateUserStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 102);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordRequest.
 * Use `create(ResetUserPasswordRequestSchema)` to create a new message.
 */
export const ResetUserPasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 103);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordResponse.
 * Use `create(ResetUserPasswordResponseSchema)` to create a new message.
 */
export const ResetUserPasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 104);

/**
 * Describes the message lease.merchant.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 105);

/**
 * Describes the message lease.merchant.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 106);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetRequest.
 * Use `create(RequestPasswordResetRequestSchema)` to create a new message.
 */
export const RequestPasswordResetRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 107);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetResponse.
 * Use `create(RequestPasswordResetResponseSchema)` to create a new message.
 */
export const RequestPasswordResetResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 108);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenRequest.
 * Use `create(ResetPasswordWithTokenRequestSchema)` to create a new message.
 */
export const ResetPasswordWithTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 109);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenResponse.
 * Use `create(ResetPasswordWithTokenResponseSchema)` to create a new message.
 */
export const ResetPasswordWithTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 110);

/**
 * Describes the message lease.merchant.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 111);

/**
 * Describes the message lease.merchant.v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 112);

/**
 * Describes the message lease.merchant.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 113);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 114);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 115);

/**
 * Describes the enum lease.merchant.v1.TrackableItemState.
 */
export const TrackableItemStateSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from enum lease.merchant.v1.TrackableItemState
 */
export const TrackableItemState = /*@__PURE__*/
  tsEnum(TrackableItemStateSchema);

/**
 * Describes the enum lease.merchant.v1.OrderStatus.
 */
export const OrderStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from enum lease.merchant.v1.OrderStatus
 */
export const OrderStatus = /*@__PURE__*/
  tsEnum(OrderStatusSchema);

/**
 * Describes the enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod.
 */
export const NotifyCustomerToCloseDoorMethodSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 2);

/**
 * @generated from enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod
 */
export const NotifyCustomerToCloseDoorMethod = /*@__PURE__*/
  tsEnum(NotifyCustomerToCloseDoorMethodSchema);

/**
 * Describes the enum lease.merchant.v1.UserStatus.
 */
export const UserStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 3);

/**
 * UserStatus defines the status of an admin user account
 *
 * @generated from enum lease.merchant.v1.UserStatus
 */
export const UserStatus = /*@__PURE__*/
  tsEnum(UserStatusSchema);

/**
 * Describes the enum lease.merchant.v1.EventType.
 */
export const EventTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 4);

/**
 * @generated from enum lease.merchant.v1.EventType
 */
export const EventType = /*@__PURE__*/
  tsEnum(EventTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeValidationType.
 */
export const VenueAccessCodeValidationTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 5);

/**
 * VenueAccessCodeValidationType defines how venue access codes are validated
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeValidationType
 */
export const VenueAccessCodeValidationType = /*@__PURE__*/
  tsEnum(VenueAccessCodeValidationTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeCharacterType.
 */
export const VenueAccessCodeCharacterTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 6);

/**
 * VenueAccessCodeCharacterType defines allowed characters in venue access codes
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeCharacterType
 */
export const VenueAccessCodeCharacterType = /*@__PURE__*/
  tsEnum(VenueAccessCodeCharacterTypeSchema);

/**
 * Describes the enum lease.merchant.v1.ActuatorType.
 */
export const ActuatorTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 7);

/**
 * ActuatorType represents the type of actuator/slave device
 *
 * @generated from enum lease.merchant.v1.ActuatorType
 */
export const ActuatorType = /*@__PURE__*/
  tsEnum(ActuatorTypeSchema);

/**
 * @generated from service lease.merchant.v1.AuthService
 */
export const AuthService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from service lease.merchant.v1.CustomerService
 */
export const CustomerService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from service lease.merchant.v1.ProductService
 */
export const ProductService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 2);

/**
 * @generated from service lease.merchant.v1.MachineService
 */
export const MachineService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 3);

/**
 * @generated from service lease.merchant.v1.OrderService
 */
export const OrderService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 4);

/**
 * @generated from service lease.merchant.v1.OrganizationService
 */
export const OrganizationService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 5);

/**
 * @generated from service lease.merchant.v1.VenueAccessCodeService
 */
export const VenueAccessCodeService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 6);

/**
 * @generated from service lease.merchant.v1.UserService
 */
export const UserService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 7);

/**
 * @generated from service lease.merchant.v1.AuditLogService
 */
export const AuditLogService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 8);

/**
 * @generated from service lease.merchant.v1.S3Service
 */
export const S3Service = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 9);

